import { useCallback, useMemo, useState } from 'react';

const useUpdate = () => {
  const [state, setState] = useState(0);
  const update = useCallback(() => setState(count => (count > 1000 ? 0 : count + 1)), [setState]);
  return useMemo(() => ({ update, value: state }), [state]);
};

export default useUpdate;
